"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGridContext = exports.GridContext = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GridContext = /*#__PURE__*/_react.default.createContext({
  columns: 12,
  columnGap: 16,
  bezelGap: 32,
  rowGap: 16,
  template: "repeat(auto-fill, 1fr)",
  breakpoints: {}
});

exports.GridContext = GridContext;

var useGridContext = function useGridContext() {
  return _react.default.useContext(GridContext);
};

exports.useGridContext = useGridContext;